<ion-content class="ion-padding">

  <div class="toPaddingTop">
    <h5><strong>A foto está legivel?</strong></h5>
    <div>
      <img [src]="'data:image/jpeg;base64,' + imageService.imageBase64Temp" alt="" class="rounded" id="image">
    </div>
  </div>

</ion-content>

<!-- Footer button -->
<ion-footer class="ion-no-border marginFooter">

  <ion-button mode="ios" expand="block" class="btn-shadow ion-margin-bottom" (click)="touchPhotoOk()">
    <ion-label><strong>Sim</strong></ion-label>
  </ion-button>

  <ion-button mode="ios" expand="block" fill="outline" (click)="touchRetakePhoto()">
    <ion-label><strong>Não, tirar outra foto</strong></ion-label>
  </ion-button>

</ion-footer>
